import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, ref } from 'vue'
import { AsyncUtil } from './AsyncUtil'
import { CheckIcon, CopyIcon } from '@zhuowenli/vue-feather-icons'
import { useClipboard } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'CopyTextButton',
  props: {
    copyText: {},
    text: {}
  },
  setup(__props: any) {

const props = __props;



const { copy } = useClipboard({ legacy: true })

const originalText = computed(() => props.text ?? 'Copy')
const recentlyCopiedRef = ref(false)
const buttonTextRef = computed(() => recentlyCopiedRef.value ? 'Copied!' : originalText.value)

onMounted(() => {
  recentlyCopiedRef.value = false
})

async function onCopy() {
  if (props.copyText) {
    copy(props.copyText)
    recentlyCopiedRef.value = true
    await AsyncUtil.delay(3000)
    recentlyCopiedRef.value = false
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["btn btn-link", { copied: recentlyCopiedRef.value }]),
    onClick: onCopy
  }, [
    (recentlyCopiedRef.value)
      ? (_openBlock(), _createBlock(_unref(CheckIcon), { key: 0 }))
      : (_openBlock(), _createBlock(_unref(CopyIcon), { key: 1 })),
    _createTextVNode(" " + _toDisplayString(buttonTextRef.value), 1)
  ], 2))
}
}

})